// 浏览器标识不是凭据：必须同时有用途前缀、截止时间、标签实例与服务端签名。
export function browserShareToken (value, purpose) {
  if (typeof value !== 'string') return null
  const match = /^(b1|c1)\.([0-9]{1,19})\.([a-f0-9]{64})\.([a-f0-9]{32})\.([A-Za-z0-9_-]{43})$/.exec(value)
  if (!match || match[1] !== purpose || !Number.isSafeInteger(Number(match[2]))) return null
  return { expiresAt: Number(match[2]), browserId: match[3], accessId: match[4] }
}

export const validShareReadToken = value => typeof value === 'string' && (/^\d+\.[A-Za-z0-9_-]{43}$/.test(value) || !!browserShareToken(value, 'b1'))
export const validShareControlToken = value => typeof value === 'string' && (/^\d+\.[a-f0-9]{64}\.[A-Za-z0-9_-]{43}$/.test(value) || !!browserShareToken(value, 'c1'))
